import React from 'react';
import { useTranslation } from "react-i18next";

export default function GroupFarmsInformationComponents() {
    const { t } = useTranslation();

    return (
        <div>
            <div className="container-fluid mt-4">
                <div className="col-sm-12 col-md-12 col-lg-11 mx-auto">
                    <div className="card">
                        <div className="card-body bg-light py-3">
                            <h5 className="card-title m-0">{t("Global_Label_Text_General")}</h5>
                        </div>

                        <div className="d-flex p-md-4 ">
                            <div className="row no-gutters text-start" style={{ maxWidth: "800px", width: "100%" }}>
                                <div className="col-md-6 card-body d-flex flex-column align-items-start">
                                    <p className="mb-3">{t("Global_Label_Text_Animals")}: <strong>500</strong></p>
                                    <p className="mb-3">{t("Global_Label_Text_Casualties")}: <strong>500</strong></p>
                                    <p className="mb-3">{t("Global_Label_Text_Start")}: <strong>500</strong></p>
                                    <p className="mb-3">{t("Global_Label_Text_Amount_Food")}: <strong>0</strong></p>
                                    <p className="mb-3">{t("Global_Label_Text_Amount_Pending_Feed")}: <strong>50%</strong></p>
                                    <p className="mb-3">{t("Global_Label_Text_Out_Stock")}: <strong>0%</strong></p>
                                </div>

                                <div className="col-md-6 card-body d-flex flex-column align-items-start" style={{ white: "250px" }}>
                                    <p className="mb-3">{t("Global_Label_Text_Behavior")}: <strong>0</strong></p>
                                    <p className="mb-3">{t("Global_Label_Text_Casualties")} (%): <strong>0%</strong></p>
                                    <p className="mb-3">{t("Global_Label_Text_End")}: <strong>1</strong></p>
                                    <p className="mb-3">{t("Global_Label_Text_Amount_Food_Given")}:</p>
                                </div>
                            </div>
                        </div>


                    </div>
                </div>
            </div>
        </div>
    );

}